import type { ModuleManifest } from "./types";

export const invoicesManifest: ModuleManifest = {
  name: "invoices",
  label: "Invoice",
  labelPlural: "Invoices",

  coreBOSModule: "InvoiceMaster",
  wsidPrefix: "69x",

  type: "master-detail",
  detailModule: "invoice-details",
  masterField: "invoicedetailtomaster",

  routes: {
    list: "/invoices",
    show: "/invoices/show/:id",
    create: "/invoices/create",
    edit: "/invoices/edit/:id",
  },

  navigation: {
    icon: "AuditOutlined",
    order: 9,
    group: "Finance",
  },

  routing: {
    keywords: ["invoice", "invoices", "bill", "bills", "fattura", "fatture"],
    searchFields: ["invoicemastername", "nrdoc", "invoicemasterno"],
    defaultSort: { field: "createdtime", order: "desc" },
  },

  context: {
    supported: true,
    entityKey: "invoices",
  },

  fields: [
    {
      name: "invoicemastername",
      label: "Invoice Name",
      type: "string",
      required: true,
    },
    { name: "nrdoc", label: "Document Number", type: "string" },
    {
      name: "invoicemasterno",
      label: "Invoice No",
      type: "string",
      readonly: true,
    },
    {
      name: "doctype",
      label: "Document Type",
      type: "picklist",
      options: [
        { value: "Invoice", label: "Invoice" },
        { value: "Credit Note", label: "Credit Note" },
        { value: "Proforma", label: "Proforma" },
      ],
    },
    {
      name: "other_vendor",
      label: "Presenter",
      type: "reference",
      referenceModule: "Vendors",
      required: true,
    },
    {
      name: "invoice_fornitore",
      label: "Supplier",
      type: "reference",
      referenceModule: "Vendors",
      required: true,
    },
    {
      name: "smownerid",
      label: "Owner",
      type: "reference",
      referenceModule: "Users",
      required: true,
      hidden: true,
      defaultValue: "19x1",
    },
    {
      name: "invoicemastertocontacts",
      label: "Contact",
      type: "reference",
      referenceModule: "Contacts",
    },
    {
      name: "inv_to_som",
      label: "Sales Order",
      type: "reference",
      referenceModule: "cbSOMaster",
    },
    {
      name: "invoice_account",
      label: "Account",
      type: "reference",
      referenceModule: "Accounts",
    },
    { name: "invoice_dataconsegna", label: "Delivery Date", type: "date" },
    {
      name: "project",
      label: "Project",
      type: "reference",
      referenceModule: "Project",
    },
    {
      name: "send_invoice",
      label: "Send Invoice",
      type: "boolean",
      defaultValue: false,
    },
    {
      name: "assigned_user_id",
      label: "Assigned To",
      type: "reference",
      referenceModule: "Users",
      hidden: true,
      defaultValue: "19x1",
    },
  ],

  relationships: [
    {
      module: "InvoiceDetails",
      field: "invoicedetailtomaster",
      relation: "one-to-many",
      label: "Line Items",
      icon: "UnorderedListOutlined",
      displayField: "invoicedetailname",
    },
    {
      module: "Accounts",
      field: "invoice_account",
      label: "Account",
      icon: "BankOutlined",
      displayField: "accountname",
    },
    {
      module: "Contacts",
      field: "invoicemastertocontacts",
      label: "Contact",
      icon: "UserOutlined",
      displayField: "lastname",
    },
    {
      module: "cbSOMaster",
      field: "inv_to_som",
      label: "Sales Order",
      icon: "ShoppingCartOutlined",
      displayField: "subject",
    },
    {
      module: "Documents",
      relation: "many-to-many",
      label: "Documents",
      icon: "FileOutlined",
      displayField: "notes_title",
    },
  ],

  requiredFields: [
    "invoicemastername",
    "other_vendor",
    "invoice_fornitore",
    "smownerid",
    "assigned_user_id",
  ],

  massEdit: {
    enabled: true,
  },
};
